import React, { useState, useRef, useEffect } from 'react';
import styles from './Chat.module.css';

const EXAMPLES = [
  'grand piano',
  'haunted music box',
  'underwater glass harp',
  'ancient bamboo flute',
  'martian steel drums',
  'broken toy piano',
  'electric guitar',
  'crystal singing bowls',
];

export default function Chat({ onGenerate, isLoading }) {
  const [messages, setMessages] = useState([
    { role: 'ai', text: 'Describe any instrument — real or imaginary — and I\'ll generate it for you to play.' }
  ]);
  const [input, setInput] = useState('');
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSend = () => {
    const val = input.trim();
    if (!val || isLoading) return;
    setMessages(prev => [...prev, { role: 'user', text: val }]);
    setMessages(prev => [...prev, { role: 'ai', text: `Generating instruments based on "${val}"... this takes about 2–4 minutes while ElevenLabs creates each note for each instrument.` }]);
    setInput('');
    onGenerate(val);
  };

  const handleExample = (ex) => {
    setInput(ex);
  };

  return (
    <div className={styles.chat}>
      <div className={styles.label}>Instrument prompt</div>

      <div className={styles.examples}>
        {EXAMPLES.map(ex => (
          <button key={ex} className={styles.exampleChip} onClick={() => handleExample(ex)}>
            {ex}
          </button>
        ))}
      </div>

      <div className={styles.messages}>
        {messages.map((m, i) => (
          <div key={i} className={`${styles.msg} ${styles[m.role]}`}>
            {m.text}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <div className={styles.inputRow}>
        <input
          className={styles.input}
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSend()}
          placeholder="e.g. spooky pipe organ..."
          disabled={isLoading}
        />
        <button
          className={styles.sendBtn}
          onClick={handleSend}
          disabled={isLoading || !input.trim()}
        >
          {isLoading ? '...' : '→'}
        </button>
      </div>
    </div>
  );
}
